import {Button, Card, Flex, Typography, theme} from 'antd';
import {BackButtonWText} from 'Components';
import {gqlSetMemberGift} from 'GQL/MethodsBFF/Gifting';
import parse from 'html-react-parser';
import React, {Fragment, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isUpdateSRList} from 'Redux/Slices/SRListFilter';
import {GIFTING} from '../giftingConstants';
import GiftDialog from './dialogs/GiftDialog';
import GiftDialogError from './dialogs/GiftDialogError';
import GiftDialogSuccess from './dialogs/GiftDialogSuccess';

interface IProps {
  toggleView?: any;
  selectedGiftOffer: any;
}

const GiftDetailView: React.FC<IProps> = (props) => {
  const {toggleView, selectedGiftOffer} = props;
  const {token}: any = theme.useToken();
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const currentMemberDetails = selectedMember.currentMemberDetails;
  const {externalRefId, memberId, clientEmail} = useSelector(
    (state: any) => state?.selectedMember?.selectedMember?.focusedMemberDetails,
  );
  let dispatch = useDispatch();

  const [openGiftingDialog, setOpenGiftingDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [manualEmailEntry, setManualEmailEntry] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmitGift = async () => {
    setLoading(true);
    const {data, error} = await gqlSetMemberGift({
      GiftingOfferRequestInput: {
        firstName: currentMemberDetails?.firstName,
        emailId: clientEmail || manualEmailEntry,
        offerId: selectedGiftOffer.id,
        merchantName: selectedGiftOffer.merchant?.name,
        titleShort: selectedGiftOffer.titleShort,
        memberId: memberId,
        memberExternalRefId: externalRefId,
      },
    });
    setLoading(false);
    if (data?.giftToCustomer) {
      setOpenGiftingDialog(false);
      setOpenSuccessDialog(true);
      dispatch(
        isUpdateSRList({
          isRefreshSRList: true,
        }),
      );
    } else if (error) {
      if (error.message.includes('MO1013')) {
        setOpenGiftingDialog(false);
        setOpenErrorDialog(true);
        setErrorMessage('MO1013');
      }
      if (error.message.includes('MO1007')) {
        setOpenGiftingDialog(false);
        setOpenErrorDialog(true);
        setErrorMessage('MO1007');
      }
    }
  };

  return (
    <Fragment>
      <Flex>
        <BackButtonWText text={GIFTING.detail_view.back_button_text} callback={toggleView} />
      </Flex>
      <div style={{marginTop: 12}}>
        <Card
          styles={{body: {padding: 32}}}
          style={{borderColor: token.colorBorderSecondary, boxShadow: token.boxShadow}}
          cover={
            <img
              src={selectedGiftOffer.images[2].imageUrl}
              alt={selectedGiftOffer.images[2].altText}
              style={{height: 200, objectFit: 'cover'}}
            />
          }>
          <Typography.Title level={4} style={{textAlign: 'center', margin: 0}}>
            {selectedGiftOffer.titleShort}
          </Typography.Title>
          <Typography.Text
            style={{display: 'block', marginTop: 8, color: token.colorTextSecondary}}>
            {parse(selectedGiftOffer.description)}
          </Typography.Text>
          <Flex justify="space-between" align="center" style={{marginTop: 32}}>
            <img src={selectedGiftOffer.images[0].imageUrl} alt="" height="40" width="40" />
            <Button type="primary" onClick={() => setOpenGiftingDialog(true)}>
              {GIFTING.detail_view.button_text}
            </Button>
          </Flex>
        </Card>
        <div style={{margin: '32px 0'}}>
          <Typography.Title level={5} style={{margin: 0}}>
            {GIFTING.detail_view.heading1}
          </Typography.Title>
          <Typography.Text
            style={{display: 'block', marginTop: 8, color: token.colorTextSecondary}}>
            {parse(selectedGiftOffer.keyTerms) || ''}
          </Typography.Text>
          <Typography.Title level={5} style={{marginTop: 32}}>
            {GIFTING.detail_view.heading2}
          </Typography.Title>
          <Typography.Text
            style={{display: 'block', marginTop: 8, color: token.colorTextSecondary}}>
            {parse(selectedGiftOffer.termsAndConditions)}
          </Typography.Text>
        </div>
        <GiftDialog
          openGiftingDialog={openGiftingDialog}
          setOpenGiftingDialog={setOpenGiftingDialog}
          handleSubmitGift={handleSubmitGift}
          customerEmail={clientEmail}
          manualEmailEntry={manualEmailEntry}
          setManualEmailEntry={setManualEmailEntry}
          loading={loading}
        />
        <GiftDialogSuccess
          customerEmail={clientEmail || manualEmailEntry}
          openSuccessDialog={openSuccessDialog}
          setOpenSuccessDialog={setOpenSuccessDialog}
        />
        <GiftDialogError
          openErrorDialog={openErrorDialog}
          setOpenErrorDialog={setOpenErrorDialog}
          errorMessage={errorMessage}
        />
      </div>
    </Fragment>
  );
};

export default GiftDetailView;
